import { ChevronDownIcon } from '@heroicons/react/24/outline'
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownTrigger,
  type Selection,
} from '@nextui-org/react'
import { __ } from '@wordpress/i18n'

import { Sort } from '../libs/type'

const sortingOptions = [
  { label: 'Default', value: Sort.Default },
  { label: 'Popularity', value: Sort.Popularity },
  { label: 'Newest', value: Sort.Date },
  { label: 'Price: Low to High', value: Sort.Price },
  { label: 'Price: High to Low', value: Sort.PriceDesc },
]

export interface DropdownSortingProps {
  onChange?: (keys: Selection) => void
  value?: Selection
}

export function DropdownSorting({
  onChange,
  value,
}: Readonly<DropdownSortingProps>) {
  return (
    <Dropdown className="uppercase">
      <DropdownTrigger>
        <Button variant="light">
          {__('Sort', 'asavagroup')} <ChevronDownIcon className="h-5 w-5" />
        </Button>
      </DropdownTrigger>
      <DropdownMenu
        aria-label={__('Sort', 'asavagroup')}
        disallowEmptySelection
        onSelectionChange={onChange}
        selectedKeys={value}
        selectionMode="single"
        variant="flat"
      >
        {sortingOptions.map((sorting) => (
          <DropdownItem key={sorting.value} textValue={sorting.value}>
            {sorting.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  )
}

export default DropdownSorting
